import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';

import { PayUSenderSelect as SENDER_SELECT } from 'Components/Api/SenderAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Hidden, Box } from '@material-ui/core';
import { Last10Report } from 'Pages/InnerPages/Report/Last10Report';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    MONEY_TRANSFER_CODE
} from 'Components/Helper/Messages';
import BeneficiaryList from './BeneficiaryList';
import HOCLoader from 'Components/Loader/HOCLoader';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { useLocation } from 'react-router-dom';

const CustomContainer = HOCLoader(Container);

export const SenderSearch = ({ ActiveDMTName }) => {
    const formRef = useRef();
    const classes = commonStyle();
    const history = useHistory();

    const [senderNo, setSenderNo] = useState('');
    const [senderID, setSenderID] = useState('');
    const [ResponseData, setResponseData] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [serviceCode, setServiceCode] = useState(MONEY_TRANSFER_CODE);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [status, setStatus] = useState('PROCESS');

    const location = useLocation();
    const Mobile = location?.state?.Mobile;

    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        SenderID: '',
        RemainingLimit: '',
        Consumed: '',
        isAddBeneficiary: false
    });

    useEffect(() => {
        setLoading(false);
        fetchSender();
    }, []);

    const fetchSender = () => {
        if (formRef === undefined) return;

        if (!formRef.current) return;

        if (formRef.current.values === undefined) return;

        if (formRef.current.values.Mobile === undefined) return;

        if (formRef.current.values.Mobile.length !== 10) return;

        formRef.current.handleSubmit();
    };

    const submithandle = async (values) => {
        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            Name: '',
            SenderID: '',
            Consumed: '',
            RemainingLimit: ''
        });

        setServiceCode('');
        setSenderID('');
        setSenderNo('');

        var requestObj = JSON.stringify(values);

        if (values.isAddBeneficiary) {
            var param = {
                Mobile: values.Mobile,
                SenderID: values.SenderID,
                SenderName: values.Name
            };
            history.push('/PU_BeneficiaryAdd', param);
            return;
        }

        setLoading(true);

        var response = await SENDER_SELECT(requestObj);

        if (!response.isAuthorized) LOGOUT();
        setServiceCode(MONEY_TRANSFER_CODE);
        setSeverity('success');

        if (!response.status) {
            var paramSender = {
                Mobile: values.Mobile
            };

            setSeverity('error');
            if (response.data === 'Sender not registered') {
                history.push('/PU_SenderAdd', paramSender);
            }

            if (response.data === 'Sender not verified') {
                history.push('/PU_SenderVerify', paramSender);
            }
            if (
                response.data ===
                'Your KYC is not approved, please contact to customer care'
            ) {
                history.push('/KycIndex');
                return;
            }
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        setAddBeneficiary('inline');

        setFormObject({
            Mobile: data.Mobile,
            Name: data.Name,
            SenderID: data.SenderID,
            Consumed: data.Consumed,
            RemainingLimit: data.RemainingLimit,
            isAddBeneficiary: false
        });
        setSenderID(data.SenderID);
        setSenderNo(data.Mobile);
        //DashboardBalanceUpdate();

        setLoading(false);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper
                                    square={false}
                                    className={classes.PaperStyle}
                                >
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialNumberField
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                placeholder="Mobile"
                                                typed_length={1}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                title="Search"
                                                disabled={loading}
                                                endIcon={<SearchIcon />}
                                                onClick={(e) => {
                                                    setFieldValue(
                                                        'isAddBeneficiary',
                                                        false
                                                    );
                                                    setAddBeneficiary('none');
                                                    handleSubmit(e);
                                                }}
                                            >
                                                Search
                                            </PrimaryButton>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Box display={addBeneficiary}>
                                                <PrimaryButton
                                                    title="Add Beneficiary"
                                                    disabled={loading}
                                                    endIcon={
                                                        <AddbeneficiaryIcon />
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddBeneficiary',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add Beneficiary
                                                </PrimaryButton>
                                            </Box>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        ></Grid>
                                    </Grid>

                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Name"
                                                name="Name"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Remaining Limit"
                                                name="RemainingLimit"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Remaining Limit"
                                            />
                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="SenderID"
                                                    name="SenderID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="SenderID"
                                                />
                                            </Hidden>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Consumed"
                                                name="Consumed"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Consumed"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            />

            <BeneficiaryList
                senderMobile={senderNo}
                ActiveDMTName={ActiveDMTName}
                senderName={formObject.Name}
                senderID={senderID}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
            <Last10Report
                ServiceID={serviceCode}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={status}
                    ServiceID={MONEY_TRANSFER_CODE}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
